import type { TratamientosModel } from 'src/app/models/tratamientos/tratamientos.model';

import { TratamientosDropdownDataSourceFactory } from './tratamientos-dropdown-datasource.factory';

/**
 * Warms row-aware dropdown data before the repeatable hydrates edition/duplication data.
 */
export class TratamientosEditStateHydrator {
    public constructor(
        private readonly dropdownDataSourceFactory: TratamientosDropdownDataSourceFactory,
    ) {}

    public async hydrate(model: TratamientosModel): Promise<void> {
        if (!this.hasRepeatableState(model)) {
            return;
        }

        await this.dropdownDataSourceFactory.primeRowsFromModel(model);
    }

    private hasRepeatableState(model: TratamientosModel): boolean {
        return [
            model.ids_productos,
            model.ids_usos,
            model.nombres_usos,
            model.ids_agentes,
            model.nombres_agentes,
        ].some((value) => String(value ?? '').trim() !== '');
    }
}
